<!--线索管理-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="120px">
          <el-form-item label="家长手机号:">
            <el-input v-model="queryParam.userPhone" placeholder="输入手机号" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="跟进人:">
            <el-input v-model="queryParam.followUpWorkerId" placeholder="输入跟进人" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="跟进阶段:">
            <el-select  v-model="queryParam.followUpStage" placeholder="请选择" @change="onChaneWork">
              <el-option
                v-for="item in followStages"
                :key="item.v"
                :label="item.des"
                :value="item.v">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下次跟进日期:">
            <el-date-picker
              v-model="queryParam.nextFollowDay"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" style="width: 120px;" icon="el-icon-folder-checked" @click="onFollowClueDlg()">跟进线索</el-button>
        <el-button type="danger" size="medium" class="operator-btn3"  icon="el-icon-guide" @click="onSelectCuleDetail()">查看线索时间线</el-button>
        <el-button type="danger" size="medium" class="operator-btn3" style="width: 120px;" icon="el-icon-guide" @click="handleAddTask()">添加任务表</el-button>

      </div>
    </div>
    <!--    查询结果区域-->
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="540"
                v-loading="listLoading" border
                highlight-current-row
                @row-click="rowClick"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="childName" label="会员姓名"></el-table-column>
        <el-table-column prop="userPhone" label="手机号"></el-table-column>
        <el-table-column prop="followedDes" label="是否跟进"></el-table-column>
        <el-table-column prop="intention" label="意向级别">
          <template slot-scope="scope" >
            <el-select  size="mini"   v-model="scope.row.intention" placeholder="未设置">
              <el-option
                         v-for="item in intentions"
                         :key="item.v"
                         :label="item.des"
                         :value="item.v">
              </el-option>
            </el-select>
          </template>


        </el-table-column>
        <el-table-column prop="followUpWorkerId" label="跟进人">
          <template slot-scope="scope" >
            <el-select  size="mini"   v-model="scope.row.followUpWorkerId" placeholder="无跟进人" >
              <el-option
                         v-for="item in allWorker"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="inviteWorker" label="邀约人">
          <template slot-scope="scope" >
            <el-select  size="mini"   v-model="scope.row.inviteWorker" placeholder="无" >
              <el-option
                         v-for="item in allWorker"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="buyCardWorker" label="成单人">
          <template slot-scope="scope" >
            <el-select  size="mini"   v-model="scope.row.buyCardWorker" placeholder="无" >
              <el-option
                         v-for="item in allWorker"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="followUpStage" label="跟进阶段">

          <template slot-scope="scope" >
            <el-select  size="mini"   v-model="scope.row.followUpStage" placeholder="无跟进人" >
              <el-option
                         v-for="item in followStages"
                         :key="item.v"
                         :label="item.des"
                         :value="item.v">
              </el-option>
            </el-select>
          </template>

        </el-table-column>
        <el-table-column prop="birthday" label="出生日期"></el-table-column>
        <el-table-column prop="nextFollowDay" label="下次跟进时间">
          <template slot-scope="scope">
            <div v-if="scope.row.followWarning == true" style="color: red">
              {{scope.row.nextFollowDay}}
            </div>
            <div v-else>
              {{scope.row.nextFollowDay}}
            </div>

          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column  label="附件">
          <template slot-scope="scope">
            <a :href="scope.row.remarkFilePath" target="_blank">{{scope.row.remarkFileName }}</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <!--    查看线索详情-->
    <el-dialog
      title="查看线索时间线"
      :visible.sync="showClueDetailDlg"
      width="50%"
      center>
      <div class="block">
        <el-timeline >
         <div>
           <el-timeline-item  timestamp="数据" placement="top">
             <el-card>
               <el-row>
                 <el-col :span="6"><div>跟进人</div></el-col>
                 <el-col :span="6"><div>跟进阶段</div></el-col>
                 <el-col :span="6"><div>意向级别</div></el-col>
               </el-row>
             </el-card>
           </el-timeline-item>
         </div>
          <div v-for="(item,index) in userClueRecordLine">
            <el-timeline-item :timestamp="item.createTime" placement="top">
              <el-card>
                <el-row>
                  <el-col :span="6"><div>{{item.workerName}}</div></el-col>
                  <el-col :span="6"><div>{{item.followStagesDes}}</div></el-col>
                  <el-col :span="6"><div>{{item.intentionDes}}</div></el-col>
                </el-row>
              </el-card>
            </el-timeline-item>
          </div>
        </el-timeline>
      </div>
      <div style="display: flex;flex-direction: column;align-items: center">

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showClueDetailDlg = false">取消</el-button>
        <el-button type="primary" size="medium" class="operator-btn" @click="onloadMoreUserClue">点击加载更多...</el-button>
      </span>
    </el-dialog>
    <!--    跟进线索-->
    <el-dialog
      title="跟进线索"
      :visible.sync="followClueDlg"
      v-if="followClueDlg"
      width="50%"
      center>
      <follow-cule :info="clueInfo" :all-worker="allWorker" @onFollowSuccess="onFollowSuccess"></follow-cule>
    </el-dialog>
  </div>



</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>

  import commonUtils from "../../../utils/commonUtils";
  import globaldata from "../../../utils/globaldata";
  import {qlUserChild} from "../../../api/userChild";
  import {queryClueRecord, queryUserClues} from "../../../api/MktClueManager";
  import {EAllFollowStage, EAllIntention} from "../../../utils/enumsUtil";
  import timeUtils from "../../../utils/timeUtils";
  import FollowCule from "../components/FollowClue";
  import messageUtils from "../../../utils/messageUtils";
  import * as enumsUtil from "../../../utils/enumsUtil";
  import {getClueFollowSetting} from "../../../api/StoreSetting";
  import {formatDate} from "../../../utils/date";

  export default {
    components: {FollowCule},
    data() {
      return {
        listLoading: true,
        showClueDetailDlg:false,
        followClueDlg:false,
        //查询参数
        queryParam: {
          followUpWorkerId:"",
          userPhone:"",//家长手机号
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },

        showWordDlg:false,
        wordTitle:"",
        refreshWord:"",
        wordType : 0,
        tData : "",

        selectRow:null,

        multipleSelection: [], //选择的表单
        //表单结果
        tableData: [
        ],
        allWorker:[],
        intentions:[],//意向级别列表
        followStages:[],//跟进阶段列表

        clueInfo:"",


        queryUserClueLine:{
          userId:0,
          pageNum:1,
          pageSize:5,
        },

        /**
         * 用户时间线记录
         */
        userClueRecordLine:[],


      }
    },

    created(){
     this.initData();
      let lett = this;
      document.onkeydown = function(e) {
        var key = window.event.keyCode;
        if (key == 13) {
          lett.onPressEnter();
        }
      }
    },
    mounted() {

    },
    methods: {




      initData(){
        this.intentions = EAllIntention();
        this.followStages = EAllFollowStage();
        globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
      },
      /**
       * 响应enter按钮
       */
      onPressEnter(e) {
        var _this = this;
        _this.flechList();

      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },
      getStoreWorkersInfo(workers){
        this.allWorker = workers;
        this.flechList();
      },
      flechList(){
        this.listLoading = true;
        let nextFollowDay = null;
        if (false == commonUtils.isObjectNull(this.queryParam.nextFollowDay)) {
          nextFollowDay = timeUtils.transDayInt(this.queryParam.nextFollowDay)
        }
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          userPhone:this.queryParam.userPhone,
          followUpStage:this.queryParam.followUpStage,
          followUpWorkerId:this.queryParam.followUpWorkerId,
          nextFollowDay:nextFollowDay,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        queryClueRecord(param).then(response => {
          this.listLoading = false;
          let data  = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.queryParam.totalPage = data.total;
          this.refreshData(data.list);

        })
      },
      rowClick(row, column, event){
        this.selectRow = row;
      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        let tableDataList = [];
        let nowDayTime = timeUtils.transDayInt( formatDate(new Date(),"yyyy-MM-dd") )
        for (let i = 0;i< list.length;++i){
          let nextFollowDay = "";
          let followWarning = false;
          let followedDes = "未跟进";
          if (commonUtils.isObjectNull(list[i].nextFollowDay) || list[i].nextFollowDay <=0){
             nextFollowDay = "无计划"

          }else {
            nextFollowDay = timeUtils.transDay(list[i].nextFollowDay)

            //已经到下次跟进日期并且没有完成的的需要显示红色的
            if (list[i].followed == false){
              //超过下次更新时间并且 不能为完成缴费状态
              if (nowDayTime >= list[i].nextFollowDay && list[i].followUpStage!= 5){
                followWarning = true;
              }
            }else {
              followedDes = "已跟进"
            }


          }


          let data = {
            id:list[i].id,
            fatherId:list[i].id,

            childId:list[i].childId,
            userId:list[i].userId,
            intention:list[i].intention,
            followUpWorkerId:list[i].followUpWorkerId,
            followUpStatu:list[i].followUpStatu,
            followUpStage:list[i].followUpStage,
            createTime:list[i].createTime,
            childName:list[i].childName,
            childPetName:list[i].childPetName,
            userPhone:list[i].userPhone,
            birthday:list[i].birthday,
            remark:list[i].remark,
            buyCardWorker:list[i].buyCardWorker,
            inviteWorker:list[i].inviteWorker,
            nextFollowDay:nextFollowDay,
            followWarning:followWarning,
            followedDes:followedDes,
            remarkFilePath:list[i].remarkFilePath,
            remarkFileName:list[i].remarkFileName,
          }
          tableDataList.push(data);
        }
        this.tableData = tableDataList;
      },
      onSelectCuleDetail(){
        if (this.handleCheckSelect() == false){
          return;
        }
        this.queryUserClueLine={
          userId:0,
            pageNum:1,
            pageSize:5,
        },
        this.userClueRecordLine =[];
        this.showClueDetailDlg = true;
        this.onLoadUserClueRecordLine();


      },
      onloadMoreUserClue(){
        this.queryUserClueLine.pageNum +=1;
        this.onLoadUserClueRecordLine();
      },

      onLoadUserClueRecordLine(){
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          userId: this.selectRow.userId,
          pageNum : this.queryUserClueLine.pageNum ,//当前第几页
          pageSize :  this.queryUserClueLine.pageSize
        }
        queryUserClues(param).then(response =>
        {

          let data  = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.refreshUserClueRecord(data);
        })
      },
      onFollowClueDlg(){
        if (this.handleCheckSelect() == false){
          return;
        }
        this.clueInfo = {
          id:this.selectRow.id,
          userId:this.selectRow.userId,
          childName:this.selectRow.childName,
          childPetName:this.selectRow.childPetName,
          userPhone:this.selectRow.userPhone,
        }
        this.followClueDlg = true;
      },

      handleCheckSelect(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.warningMsg(this,"请先选择一条信息");
          return false;
        }
        return true;
      },
      onFollowSuccess(){
        this.followClueDlg = false;
        this.flechList();
      },

      refreshUserClueRecord(list){
        if (commonUtils.isArrayNull(list)) {
          messageUtils.warningMsg(this,"已经到底了!!!");
          return;
        }

        for (let i = 0;i<list.length;++i){
          let record = list[i];
          record.intentionDes = enumsUtil.getEnumDesByV(record.intention,this.intentions)
          record.followStagesDes = enumsUtil.getEnumDesByV(record.followUpStage,this.followStages)
          record.workerName = this.getWorker(record.followUpWorkerId)
          this.userClueRecordLine.push(list[i]);
        }


      },
      getWorker(id){
        for (let i = 0;i< this.allWorker.length;++i){
          if (id == this.allWorker[i].id){
            return this.allWorker[i].name;
          }
        }
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
      },

      handleAddTask(){
        if (this.multipleSelection.length<=0){
          messageUtils.errorMsg(this,"请勾选数据!!")
          return;
        }
        let data = {
          taskType: 4,
          pList:[],
        }
        let pList = data.pList;
        for (let i = 0;i<this.multipleSelection.length;++i){
          pList.push({childName:this.multipleSelection[i].childName,userId:this.multipleSelection[i].userId,phoneNumber:this.multipleSelection[i].userPhone})
        }
        this.$router.push({path: '/myStore/AddWorkerTask',query:data})

      }

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/marketing-manager/clue-manager/index.vue